const step_up = {
    verify_your_identity: 'Xác minh danh tính của bạn',
    choose_method_description: 'Để tiếp tục, hãy xác nhận đó là bạn bằng một trong các phương thức sau.',
    password: 'Mật khẩu',
    password_description: 'Nhập mật khẩu tài khoản của bạn',
    enter_password_description: 'Nhập mật khẩu tài khoản của bạn để tiếp tục.',
    enter_verification_code_description: 'Nhập mã xác minh đã gửi đến {{identifier}}.',
    subject_proof_description: 'Để tiếp tục, hãy xác nhận đó là bạn thông qua một tài khoản đã liên kết với tài khoản của bạn. Sau đó bạn có thể thiết lập phương thức xác minh.',
    no_method_available: 'Không có phương thức xác minh khả dụng',
    no_method_available_description: 'Tài khoản của bạn không có phương thức nào để hoàn tất xác minh này. Vui lòng liên hệ quản trị viên để được hỗ trợ.',
};
export default Object.freeze(step_up);
